import './phone-span.scss';

export interface PhoneSpanProps {
  phone: string;
  className?: string;
  dir?: string;
}

const PhoneSpan = (props: PhoneSpanProps) => {
  return (
    <span className={props.className} dir={props.dir}>
      <a href={`tel:${props.phone}`}>{props.phone}</a>
    </span>
  );
};

export default PhoneSpan;
